/*
 * @Description:
 * @Author: Ian
 * @Date: 2023-10-19 16:59:15
 * @LastEditTime: 2023-10-20 13:53:54
 * @LastEditors: Ian
 */
import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  SiVisualstudiocode,
  SiPostman,
  SiVercel,
  SiAdobephotoshop,
  SiSublimetext,
  SiCanva,
} from "react-icons/si";
import { AiFillWindows, AiFillAndroid, AiFillApple } from "react-icons/ai";

function Toolstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <AiFillWindows />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiVisualstudiocode />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiPostman />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiVercel />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiAdobephotoshop />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiSublimetext />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiCanva />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <AiFillAndroid />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <AiFillApple />
      </Col>
    </Row>
  );
}

export default Toolstack;
